import { RootState } from "../store";

export const selectPositiveItem = (state: RootState) => state.positiveItem;

export const selectPositiveItems = (state: RootState) => state.positiveItem.data;

export const selectPositiveItemToEdit = (state: RootState) => state.positiveItem.toEdit;

export const selectPositiveItemToEditImages = (state: RootState) => state.positiveItem.toEditImages;

export const selectPositiveItemsToDelete = (state: RootState) => state.positiveItem.toDelete;

export const selectPositiveItemDeleteDialog = (state: RootState) => state.positiveItem.showDeleteSelected;

export const selectPositiveItemFailed = (state: RootState) => state.positiveItem.failed;